<div [class]="`ai-radio-group ${cssClass()}`">
    <ul>
        <li
            *ngFor="let element of options()"
            (click)="onSelectionChange(element)"
            [ngClass]="{
                'ai-radio-option': true,
                'ai-radio-option-selected': element.value === option().value,
            }"
        >
            <input
                type="radio"
                class="ai-radio-input"
                [value]="element.value"
                [checked]="element.value === option().value"
                (change)="onSelectionChange(element)"
            />
            <label>
                {{ element.label }}
            </label>
        </li>
    </ul>
</div>
